import React from 'react';
import { Box } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { ComponentInfo, EnterpriseSolutions } from '@components';
import { useEnterpriseSolution } from '@store';

export const EnterpriseSolutionPlaceholder: React.FC = () => {
	const solutions = useEnterpriseSolution();

	return (
		<ComponentInfo name="EnterpriseSolutionPlaceholder">
			<Box styles={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
				<EnterpriseSolutions solutions={solutions} />
			</Box>
		</ComponentInfo>
	);
};
